export const BASIC_FORM_DATA_RESPONSE = () => {
    return {
        data: {
            statusCode: 'SPGM-0000',
            errorMessage: null,
            basicSectionData: {
                feeCriteria: ['MINIMUM', 'MAXIMUM', 'BOTH'],
                accountTypes: [
                    'All Account Types',
                    'CC',
                    'CREDIT_LINE',
                    'SAVINGS_ACCOUNT',
                    'WALLET',
                ],
                schemes: ['AMEX', 'All Schemes', 'DINR', 'MC', 'RPAY', 'VI'],
                PgMidBasicFees: [
                    {
                        feePercent: 0.0,
                        feeFlat: 0.0,
                        feeCriteria: 'MINIMUM',
                        tax: 18.0,
                        currency: 'INR',
                        lowerSlab: '2000.0',
                        higherSlab: null,
                        paymentType: 'DC',
                        category: null,
                        feeType: null,
                        feeEntityId: null,
                        cardType: null,
                        domesticFlag: 1,
                        onUsFlag: false,
                        entityType: null,
                        accountType: null,
                        transactionType: null,
                        cardCategory: null,
                    },
                    {
                        feePercent: 0.0,
                        feeFlat: 0.0,
                        feeCriteria: 'MINIMUM',
                        tax: 18.0,
                        currency: 'INR',
                        lowerSlab: '0.0',
                        higherSlab: '2000.0',
                        paymentType: 'DC',
                        category: null,
                        feeType: null,
                        feeEntityId: null,
                        cardType: null,
                        domesticFlag: 1,
                        onUsFlag: false,
                        entityType: null,
                        accountType: null,
                        transactionType: null,
                        cardCategory: null,
                    },
                    {
                        feePercent: 0.0,
                        feeFlat: 0.0,
                        feeCriteria: 'MINIMUM',
                        tax: 18.0,
                        currency: 'INR',
                        lowerSlab: '0.0',
                        higherSlab: '2000.0',
                        paymentType: 'DC',
                        category: null,
                        feeType: null,
                        feeEntityId: null,
                        cardType: null,
                        domesticFlag: 0,
                        onUsFlag: false,
                        entityType: null,
                        accountType: null,
                        transactionType: null,
                        cardCategory: null,
                    },
                    {
                        feePercent: 0.0,
                        feeFlat: 0.0,
                        feeCriteria: 'MINIMUM',
                        tax: 18.0,
                        currency: 'INR',
                        lowerSlab: '2000.0',
                        higherSlab: null,
                        paymentType: 'DC',
                        category: null,
                        feeType: null,
                        feeEntityId: null,
                        cardType: null,
                        domesticFlag: 0,
                        onUsFlag: false,
                        entityType: null,
                        accountType: null,
                        transactionType: null,
                        cardCategory: null,
                    },
                    {
                        feePercent: 0.0,
                        feeFlat: 0.0,
                        feeCriteria: 'MINIMUM',
                        tax: 18.0,
                        currency: 'INR',
                        lowerSlab: '0.0',
                        higherSlab: null,
                        paymentType: 'CC',
                        category: null,
                        feeType: null,
                        feeEntityId: null,
                        cardType: null,
                        domesticFlag: 1,
                        onUsFlag: false,
                        entityType: null,
                        accountType: null,
                        transactionType: null,
                        cardCategory: null,
                    },
                    {
                        feePercent: 0.0,
                        feeFlat: 0.0,
                        feeCriteria: 'MINIMUM',
                        tax: 18.0,
                        currency: 'INR',
                        lowerSlab: '0.0',
                        higherSlab: null,
                        paymentType: 'CC',
                        category: null,
                        feeType: null,
                        feeEntityId: null,
                        cardType: null,
                        domesticFlag: 0,
                        onUsFlag: false,
                        entityType: null,
                        accountType: null,
                        transactionType: null,
                        cardCategory: null,
                    },
                    {
                        feePercent: 0.0,
                        feeFlat: 0.0,
                        feeCriteria: 'MINIMUM',
                        tax: 18.0,
                        currency: 'INR',
                        lowerSlab: '0.0',
                        higherSlab: null,
                        paymentType: 'NB',
                        category: null,
                        feeType: null,
                        feeEntityId: null,
                        cardType: null,
                        domesticFlag: 1,
                        onUsFlag: false,
                        entityType: null,
                        accountType: null,
                        transactionType: null,
                        cardCategory: null,
                    },
                ],
            },
        },
    };
};
